import React, { useEffect, useState } from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { useCountdown } from '../hooks/useCountdown';
import { Lock, Smartphone, RefreshCcw, CreditCard } from 'lucide-react';
export function FinalCTASection() {
  const {
    ref,
    isVisible
  } = useScrollAnimation();
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(0, 30, 0);
  const [particles, setParticles] = useState<{
    id: number;
    left: string;
    size: number;
    delay: string;
    duration: string;
  }[]>([]);
  useEffect(() => {
    const newParticles = Array.from({
      length: 15
    }).map((_, i) => ({
      id: i,
      left: `${Math.random() * 100}%`,
      size: Math.random() * 3 + 2,
      delay: `${Math.random() * 5}s`,
      duration: `${Math.random() * 8 + 8}s`
    }));
    setParticles(newParticles);
  }, []);
  return <section id="checkout" className="relative w-full bg-navy py-24 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-26">
      {/* Particles */}
      {particles.map(p => <div key={p.id} className="absolute bottom-0 rounded-full bg-gold animate-particle-float" style={{
      left: p.left,
      width: `${p.size}px`,
      height: `${p.size}px`,
      animationDelay: p.delay,
      animationDuration: p.duration
    }} data-id="element-27" />)}

      <div ref={ref} className={`relative z-10 max-w-4xl mx-auto text-center transition-all duration-1000 transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-28">
        <h2 className="font-playfair font-bold text-3xl sm:text-[46px] leading-[1.2] text-white mb-6" data-id="element-29">
          Esta es la <span className="text-gold" data-id="element-30">Última Vez</span> que Vas a
          Gastar Plata en PDFs de Otros
        </h2>

        <p className="font-inter text-xl text-[#A8B2D8] mb-12 max-w-2xl mx-auto" data-id="element-31">
          Hoy tomás el control de tu tiempo, tu planificación y tu independencia
          profesional. Para siempre.
        </p>

        <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 sm:p-12 mb-8" data-id="element-32">
          {/* What you get */}
          <div className="text-left max-w-md mx-auto mb-10 space-y-3" data-id="element-33">
            <p className="font-montserrat font-bold text-white text-sm uppercase tracking-wider text-center mb-4" data-id="element-34">
              🎁 Con tu compra recibís:
            </p>
            <div className="flex items-start gap-3" data-id="element-35">
              <span className="text-gold text-lg leading-none mt-0.5" data-id="element-36">📘</span>
              <span className="font-inter text-white text-[15px]" data-id="element-37">
                <strong data-id="element-38">Manual Completo "IA Práctica para Docentes"</strong>
              </span>
            </div>
            <div className="flex items-start gap-3" data-id="element-39">
              <span className="text-gold text-lg leading-none mt-0.5" data-id="element-40">🎁</span>
              <span className="font-inter text-white text-[15px]" data-id="element-41">
                <strong data-id="element-42">Bonus 1:</strong> Banco Universal de Prompts Docentes
                Inteligentes{' '}
                <span className="text-emerald font-bold" data-id="element-43">— GRATIS</span>
              </span>
            </div>
            <div className="flex items-start gap-3" data-id="element-44">
              <span className="text-gold text-lg leading-none mt-0.5" data-id="element-45">🎁</span>
              <span className="font-inter text-white text-[15px]" data-id="element-46">
                <strong data-id="element-47">Bonus 2:</strong> Sistema "Planificación 10X" Paso a
                Paso <span className="text-emerald font-bold" data-id="element-48">— GRATIS</span>
              </span>
            </div>
            <div className="flex items-start gap-3" data-id="element-49">
              <span className="text-gold text-lg leading-none mt-0.5" data-id="element-50">🎁</span>
              <span className="font-inter text-white text-[15px]" data-id="element-51">
                <strong data-id="element-52">Bonus 3:</strong> Creá tu Propio Material Digital{' '}
                <span className="text-emerald font-bold" data-id="element-53">— GRATIS</span>
              </span>
            </div>
          </div>

          {/* Price */}
          <div className="mb-2" data-id="element-54">
            <span className="font-inter font-bold text-white text-xl uppercase tracking-wider" data-id="element-55">
              HOY SOLO:
            </span>
          </div>
          <div className="mb-4" data-id="element-56">
            <span className="font-montserrat font-extrabold text-[52px] sm:text-[64px] text-gold leading-none drop-shadow-[0_0_15px_rgba(245,166,35,0.3)]" data-id="element-57">
              $19.990
            </span>
          </div>
          <div className="mb-10" data-id="element-58">
            <span className="font-inter text-gray-400 line-through text-lg" data-id="element-59">
              Valor real del paquete: $64.000
            </span>
          </div>

          <a href="https://checkout8.rosetadigital.com/cart/51827041960167:1" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto inline-block text-center bg-gold text-navy font-montserrat font-extrabold text-lg sm:text-xl py-6 px-8 sm:px-14 rounded-xl shadow-[0_0_40px_rgba(245,166,35,0.5)] hover:scale-105 hover:bg-[#ffb43a] transition-all duration-300 animate-pulse-glow mb-8" data-id="element-60">
            SÍ, QUIERO MI INDEPENDENCIA DOCENTE →
          </a>

          <div className="flex flex-wrap justify-center gap-4 sm:gap-8 text-sm text-[#A8B2D8] font-inter mb-8" data-id="element-61">
            <div className="flex items-center gap-2" data-id="element-62">
              <Lock size={18} data-id="element-63" />
              <span data-id="element-64">Pago Seguro SSL</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-65">
              <Smartphone size={18} data-id="element-66" />
              <span data-id="element-67">Acceso Inmediato</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-68">
              <RefreshCcw size={18} data-id="element-69" />
              <span data-id="element-70">Garantía 7 Días</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-71">
              <CreditCard size={18} data-id="element-72" />
              <span data-id="element-73">Todas las Tarjetas</span>
            </div>
          </div>

          <div className="inline-flex items-center justify-center bg-crimson rounded-full px-6 py-3 shadow-lg" data-id="element-74">
            <span className="font-montserrat font-bold text-white text-sm sm:text-base tracking-wide flex items-center gap-2" data-id="element-75">
              ⚡ Esta oferta vence en:{' '}
              <span className="tabular-nums" data-id="element-76">
                {hours}:{minutes}:{seconds}
              </span>
            </span>
          </div>
        </div>
      </div>
    </section>;
}